import { c as _c } from "react/compiler-runtime";
import { useQuery, useSubscription } from '@apollo/client/react';
import { NavItem } from '@src/components/sco/nav/ScoSiteNavBar/index';
import { gql } from '@src/lib/gql';
import React, { useMemo } from 'react';
import { MdChat } from 'react-icons/md';
export const ChatSiteNavBarItem = props => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query {
        currentUser {
          id
          directChatThreadsUnreadCommentsCount
        }
      }
    `;
    t1 = {
      ssr: false
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = gql`
    subscription {
      scoUserDirectChatViewed {
        user {
          id
          directChatThreadsUnreadCommentsCount
        }
      }
    }
  `;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useSubscription(t2);
  const queryUser = query.data?.currentUser;
  queryUser?.directChatThreadsUnreadCommentsCount;
  const chatNotificationCount = queryUser?.directChatThreadsUnreadCommentsCount || 0;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      children: <MdChat />,
      fontSize: "1em",
      href: "/inbox",
      padding: 0,
      variant: "ghost",
      width: "auto"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== chatNotificationCount) {
    t4 = <NavItem {...{
      buttonProps: t3,
      ...(chatNotificationCount > 0 ? {
        badgeProps: {
          fontSize: "11px",
          variant: "count",
          position: "absolute",
          right: "-2",
          textAlign: "center",
          children: <>{chatNotificationCount}</>
        }
      } : {})
    }} />;
    $[4] = chatNotificationCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};